import { LeftPanel } from "helpers/constants";
import { AppAction, AppContext, setLeftPanel } from "helpers/context";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as AdminSvg } from "../../assets/admin.svg";
import { ReactComponent as LayersSvg } from "../../assets/icon_layers.svg";
import { ReactComponent as EventsSvg } from "../../assets/icon_events.svg";
import { ReactComponent as LocationsSvg } from "../../assets/icon_locations.svg";
import { ReactComponent as MyShapesSvg } from "../../assets/icon_my_shapes.svg";

import styles from "./sidebar.module.scss";

function Sidebar() {
  const [context, dispatch] = useContext(AppContext);
  const [t] = useTranslation();

  const getClass = (leftPanel: LeftPanel): string =>
    context.leftPanel === leftPanel ? styles.itemActive : styles.item;

  return (
    <div className={styles.sidebar}>
      {context.menu && context.menu.find((item) => item.id === "101") && (
        <div
          className={getClass(LeftPanel.Layers)}
          onClick={() => {
            dispatch({ type: AppAction.setArrowLeft, payload: false });
            dispatch({ type: AppAction.setLocationsSize, payload: false });
            setLeftPanel(
              dispatch,
              context.leftPanel === LeftPanel.Layers
                ? LeftPanel.Empty
                : LeftPanel.Layers
            );
          }}
        >
          <div className={styles.icon}>
            <LayersSvg className={styles.image} />
          </div>
          <div className={styles.text}>{t("layers.title")}</div>
        </div>
      )}
      {context.menu &&
        context.menu.find(
          (item) => item.id === "104001" && item.status === "1"
        ) && (
          <div
            className={getClass(LeftPanel.Events)}
            onClick={() => {
              dispatch({ type: AppAction.setArrowLeft, payload: false });
              dispatch({ type: AppAction.setLocationsSize, payload: false });
              setLeftPanel(
                dispatch,
                context.leftPanel === LeftPanel.Events
                  ? LeftPanel.Empty
                  : LeftPanel.Events
              );
            }}
          >
            <div className={styles.icon}>
              <EventsSvg className={styles.image} />
            </div>
            <div className={styles.text}>{t("events.title")}</div>
          </div>
        )}
      {context.menu && context.menu.find((item) => item.id === "103") && (
        <div
          className={
            context.leftPanel &&
              (context.leftPanel === LeftPanel.Locations ||
                context.leftPanel === LeftPanel.AddLocation ||
                context.leftPanel === LeftPanel.EditLocation ||
                context.leftPanel === LeftPanel.EditLocationSet)
              ? styles.itemActive
              : styles.item
          }
          // className={getClass(LeftPanel.Locations)}
          onClick={() => {
            dispatch({ type: AppAction.setArrowLeft, payload: false });
            dispatch({ type: AppAction.setLocationsSize, payload: false });
            setLeftPanel(
              dispatch,
              context.leftPanel &&
                (context.leftPanel === LeftPanel.Locations ||
                  context.leftPanel === LeftPanel.AddLocation ||
                  context.leftPanel === LeftPanel.EditLocation ||
                  context.leftPanel === LeftPanel.EditLocationSet)
                ? LeftPanel.Empty
                : LeftPanel.Locations
            );
          }}
        >
          <div className={styles.icon}>
            <LocationsSvg className={styles.image} />
          </div>
          <div className={styles.text}>{t("locations.title")}</div>
        </div>
      )}
      {context.menu && context.menu.find((item) => item.id === "105005") && (
        <div
          className={
            context.leftPanel && context.leftPanel === LeftPanel.MyShapes
              ? styles.itemActive
              : styles.item
          }
          onClick={() => {
            dispatch({ type: AppAction.setArrowLeft, payload: false });
            dispatch({ type: AppAction.setLocationsSize, payload: false });
            setLeftPanel(
              dispatch,
              context.leftPanel && context.leftPanel === LeftPanel.MyShapes
                ? LeftPanel.Empty
                : LeftPanel.MyShapes
            );
          }}
        >
          <div className={styles.icon}>
            <MyShapesSvg className={styles.image} />
          </div>
          <div className={styles.text}>{t("myShapes.title")}</div>
        </div>
      )}
      {context.menu && context.menu.find((item) => item.id === "100") && (
        <div
          className={
            context.leftPanel && context.leftPanel === LeftPanel.UserSystem
              ? styles.itemActive
              : styles.item
          }
          onClick={() => {
            dispatch({ type: AppAction.setArrowLeft, payload: false });
            dispatch({ type: AppAction.setLocationsSize, payload: false });
            setLeftPanel(
              dispatch,
              context.leftPanel && context.leftPanel === LeftPanel.UserSystem
                ? LeftPanel.Empty
                : LeftPanel.UserSystem
            );
          }}
        >
          <div className={styles.icon}>
            <AdminSvg className={styles.image} />
          </div>
          <div className={styles.text}>{t("userSystem.title")}</div>
        </div>
      )}
    </div>
  );
}

export default Sidebar;
